import { ColorPicker, Typography } from "antd";
import { memo, useCallback } from "react";

const { Text } = Typography;

// ── Defined OUTSIDE ThemeCustomizer so it has a stable identity ──────────────
interface ColorRowProps {
    fieldKey: keyof ICustomizationData;
    label: string;
    value: string;
    onUpdate: (key: keyof ICustomizationData, hex: string) => void;
    testId?: string;
}

const ColorRow = memo(function ColorRow({ fieldKey, label, value, onUpdate, testId }: ColorRowProps) {
    const handleChange = useCallback(
        (c: Parameters<NonNullable<React.ComponentProps<typeof ColorPicker>["onChangeComplete"]>>[0]) => onUpdate(fieldKey, c.toHexString()),
        [fieldKey, onUpdate],
    );
    return (
        <div className="flex items-center justify-between py-1.5" data-testid={testId}>
            <Text type="secondary" className="flex-1 text-xs">
                {label}
            </Text>
            <div className="flex items-center gap-2">
                <Text type="secondary" className="font-mono text-xs">
                    {value.toUpperCase()}
                </Text>
                <ColorPicker size="small" value={value} onChangeComplete={handleChange} destroyOnHidden />
            </div>
        </div>
    );
});

export default ColorRow;
